<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 100 100"
    enable-background="new 0 0 100 100"
    xml:space="preserve">
    <path
      d="M29,21.258c-1.104,0-2,0.896-2,2v54.432c0,1.104,0.896,2,2,2s2-0.896,2-2V53.831
    c0.286,0.275,0.516,0.443,0.583,0.491c0.029,0.02,0.058,0.039,0.087,0.058l36.346,22.827c1.878,1.23,3.855,1.451,5.426,0.602
    C75.068,76.931,76,75.051,76,72.65V28.297c0-2.4-0.932-4.28-2.558-5.158c-1.57-0.848-3.549-0.628-5.393,0.583L31.671,46.57
    c-0.03,0.019-0.059,0.038-0.087,0.058c-0.068,0.048-0.297,0.216-0.583,0.491V23.258C31,22.153,30.104,21.258,29,21.258z
    M33.863,49.917L70.21,27.088c0.704-0.462,1.181-0.51,1.332-0.429C71.719,26.754,72,27.284,72,28.297V72.65
    c0,1.014-0.281,1.543-0.458,1.639c-0.151,0.081-0.629,0.032-1.365-0.449L33.872,51.038c-0.202-0.163-0.42-0.437-0.447-0.563
    C33.452,50.345,33.677,50.064,33.863,49.917z" />
  </svg>
</template>
